import { createContext } from 'react'
import type { TAuthContextValue } from './auth.types'

export const AuthContext = createContext<TAuthContextValue | null>(null)
AuthContext.displayName = 'AuthContext'
